import React, { useEffect } from 'react';
import AvisoPrivacidadForm from '../AvisoPrivacidad/AvisoPrivacidadForm';

const HUBSPOT_SCRIPT = '//js.hsforms.net/forms/embed/v2.js';

function FormularioContactoSpcPremium() {
  useEffect(() => {
    const crearFormulario = () => {
      const target = document.getElementById('hubspotForm');
      // Evita duplicar el formulario (StrictMode / re-montajes)
      if (!window.hbspt || !target || target.hasChildNodes()) return;

      window.hbspt.forms.create({
        portalId: '47654427',
        formId: '7e42a680-095f-4d2f-a05b-875b27974ea8',
        target: '#hubspotForm',
      });
    };

    // Si HubSpot ya está cargado (visita previa a otra landing), se reutiliza
    if (window.hbspt) {
      crearFormulario();
      return undefined;
    }

    // Reutiliza el <script> si ya existe en vez de añadir uno nuevo en cada montaje
    let script = document.querySelector(`script[src="${HUBSPOT_SCRIPT}"]`);
    if (!script) {
      script = document.createElement('script');
      script.src = HUBSPOT_SCRIPT;
      script.type = 'text/javascript';
      script.charset = 'utf-8';
      document.body.appendChild(script);
    }

    script.addEventListener('load', crearFormulario);
    return () => script.removeEventListener('load', crearFormulario);
  }, []);

  return (
    <section id="contacto" className="bg-light spc-section">
      <div className="container">
        <div className="title-style2 text-center mb-2-2">
          <h2 className="h1">¡Contáctanos para más información del Piso SPC Luxury y una cotización personalizada!</h2>
        </div>
        <div className="row">
          <div className="col-lg-8 mb-5 mb-lg-0 mb-md-5 mx-auto wow fadeIn" data-wow-delay="400ms">
            <div className="contact-form p-4 p-md-5 bg-white rounded">
              <form className="quform">
                {/* Aquí se insertará el formulario de HubSpot */}
                <div id="hubspotForm"></div>
                <AvisoPrivacidadForm />
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default FormularioContactoSpcPremium;